import styled, { css, keyframes } from 'styled-components';
import { variant } from 'styled-system';

import { ThemeUtilities } from '../../../theme';
import { ComponentSize } from '../types';

import { ButtonColor, ButtonColorVariant, ButtonFill } from './types';
import { fontSmoothing } from '../../../mixins';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const commonStyle = css`
  outline: none;
  border: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  column-gap: 8px;
  cursor: pointer;
  box-sizing: border-box;
  ${fontSmoothing};

  transition: background-color 250ms ease-in-out, color 250ms ease-in-out,
    box-shadow 250ms ease-in-out;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const StyledButton = styled.button<{
  colorVariant: ButtonColorVariant;
  size: ComponentSize;
  fill: ButtonFill;
  color: ButtonColor;
  isLoading?: boolean;
  disabled: boolean;
  hasIconOnly: boolean;
}>`
  ${commonStyle};

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Button', 'size'))};
  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Button', 'color'))};

  ${({ hasIconOnly, theme, size }) =>
    hasIconOnly &&
    css`
      padding-left: ${size === 'medium'
        ? theme.space[4] - 1
        : theme.space[3] - 1}px;
      padding-right: ${size === 'medium'
        ? theme.space[4] - 1
        : theme.space[3] - 1}px;
      aspect-ratio: 1;
    `};

  ${({ isLoading, disabled, color, theme }) =>
    isLoading &&
    !disabled &&
    css`
      color: ${color === 'secondary'
        ? theme.colors.gray.dark
        : theme.colors[color].light};
      pointer-events: none;
    `};

  ${css((props) => ThemeUtilities.getComponentCSSOverrides(props, 'Button'))};
`;

export const Rotate = styled.div`
  display: flex;
  animation: ${rotate} 2s linear infinite;
`;

export const IconContainer = styled.div<{
  iconSize: ComponentSize;
}>`
  display: flex;
  justify-content: center;

  ${(props) =>
    variant(ThemeUtilities.getComponentVariant(props, 'Button', 'iconSize'))};
`;
